var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      staticStyle: { width: "100%" },
      attrs: {
        border: "",
        "header-cell-style": {
          backgroundColor: "#FDEFE7",
          color: "#000000",
        },
        data: _vm.tableData,
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          fixed: "left",
          align: "center",
          prop: "date",
          label: "操作者类型",
          width: "120",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "name",
          label: "供应商名称",
          width: "200",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "address",
          label: "操作者信息",
          width: "120",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "name",
          label: "操作时间",
          width: "120",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "name",
          label: "触发原因/按键",
          width: "120",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "name",
          label: "操作后订单状态",
          width: "180",
        },
      }),
      _c("el-table-column", {
        attrs: { align: "center", prop: "name", label: "备注" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }